<template>
  <div class="page">
    <div class="name">支付聚合平台</div>
    <div class="content">
      <!-- 左侧图案 -->
      <leftImg></leftImg>
      <!-- 注册 -->
      <div class="right">
        <p class="name">设置信息</p>
        <div class="error">{{ errorMsg }}</div>
        <el-form :model="registerForm" class="form">
          <el-form-item>
            <el-input v-model="registerForm.companyName" placeholder="请输入公司全称" maxlength="40" />
          </el-form-item>
          <!-- 行业 -->
          <el-form-item>
            <div class="industry">
              <el-select
                v-model="registerForm.primaryIndustry"
                @change="onChangePrimary"
                placeholder="请选择一级行业"
                filterable
                clearable
              >
                <el-option
                  v-for="item in industryOptions"
                  :key="item.value + item.label"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select v-model="registerForm.secondaryIndustry" placeholder="请选择二级行业" filterable clearable>
                <el-option
                  v-for="item in secIndustryOptions"
                  :key="item.dicCode + item.dicName"
                  :label="item.dicName"
                  :value="item.dicCode"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <!-- 公司规模 -->
          <el-form-item>
            <el-select class="scale" v-model="registerForm.scale" placeholder="公司规模" clearable>
              <el-option v-for="item in scaleOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="contacts">联系人地址</el-form-item>
          <el-form-item>
            <div class="industry address">
              <el-select
                v-model="registerForm.province"
                placeholder="省份"
                filterable
                clearable
                @change="onChangeProvince"
              >
                <el-option
                  v-for="item in provinceOptions"
                  :key="item.value + item.label"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select v-model="registerForm.city" placeholder="城市" filterable clearable @change="onChangeCity">
                <el-option
                  v-for="item in cityOptions"
                  :key="item.dicCode + item.dicName"
                  :label="item.dicName"
                  :value="item.dicCode"
                ></el-option>
              </el-select>
              <el-select v-model="registerForm.district" placeholder="区县" filterable clearable>
                <el-option
                  v-for="item in districtOptions"
                  :key="item.dicName + item.dicCode"
                  :label="item.dicName"
                  :value="item.dicCode"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item>
            <el-input v-model="registerForm.name" placeholder="联系人姓名" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="registerForm.password"
              placeholder="请输入密码（6-20位，包括大小写）"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="registerForm.checkPassword" placeholder="请再次输入密码" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="registerForm.mobile" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="registerForm.authCode" placeholder="请输入验证码" maxlength="10">
              <template slot="append">
                <div v-if="vertifySendStatus" @click="sendCode()">{{ sendBtnText }}</div>
                <div v-else>{{ vertifyCodeTime }}s</div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item class="other">确认信息填写完整，点击按钮完成注册</el-form-item>
          <el-form-item>
            <el-button class="login-btn" type="primary" @click="submitForm()">注册</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import leftImg from '@login/components/leftImg';
import { checkRegisterFormFormat, checkMobileFormat } from '../../static/loginUtil';
export default {
  components: {
    leftImg,
  },
  data() {
    return {
      registerForm: {
        companyName: '', // 公司名称
        primaryIndustry: '', // 一级行业
        secondaryIndustry: '', // 二级行业
        scale: '', // 公司规模,
        province: '', // 省
        city: '', // 市
        district: '', // 区
        name: '', // 联系人姓名
        password: '', // 密码
        checkPassword: '', // 再次输入密码
        mobile: '', // 手机号
        authCode: '', // 手机验证码
        authKey: '', // 手机验证码唯一标识
        contactAddress: '', // 联系地址
        qqNumber: '', // qq号
      },
      secIndustryOptions: [], // 二级行业列表
      scaleOptions: ['0-5人', '5-20人', '20-100人', '100人以上'], // 公司规模列表
      cityOptions: [], // 城市选项列表
      districtOptions: [], // 区县选项列表
      errorMsg: '', //错误语提示
      vertifySendStatus: 1, // 验证码发送状态 0: 不可重新发送 1: 可重新发送
      vertifyCodeTime: 60, // 重新发送计时
      timer: null, // 计时器
      sendBtnText: '发送验证码',
    };
  },
  computed: {
    ...mapGetters('login', ['industryOptions', 'provinceOptions']),
  },
  created() {
    this.getInitData();
  },
  methods: {
    ...mapActions('login', [
      'getIndustryOptions',
      'getAddressOptions',
      'getPhoneVerifyCode',
      'checkPhoneVerifyCode',
      'submitUserRegister',
    ]),

    // 监听一级行业选项变化
    onChangePrimary(currentVal) {
      // 清空当前二级行业选项
      this.registerForm.secondaryIndustry = '';
      this.secIndustryOptions = [];
      if (currentVal) {
        // 找到当前所选一级行业下的子行业（二级行业列表）
        const currentIndustry = this.industryOptions.find(firIndustry => {
          return firIndustry.value === currentVal;
        });
        this.secIndustryOptions = [...currentIndustry.children];
      }
    },

    // 监听省份选项变化
    onChangeProvince(currentVal) {
      // 清空城市和区县选项
      this.registerForm.city = '';
      this.registerForm.district = '';
      this.cityOptions = [];
      this.districtOptions = [];
      if (currentVal) {
        // 找到当前所选省份下的城市列表
        const currentProvince = this.provinceOptions.find(province => {
          return province.value === currentVal;
        });
        this.cityOptions = [...currentProvince.children];
      }
    },

    // 监听城市选项变化
    onChangeCity(currentVal) {
      // 清空区县选项
      this.registerForm.district = '';
      this.districtOptions = [];
      if (currentVal) {
        // 找到当前所选城市下的区县列表
        const currentCity = this.cityOptions.find(city => {
          return city.dicCode === currentVal;
        });
        this.districtOptions = [...currentCity.childrenRes];
      }
    },

    // 发送手机验证码
    async sendCode() {
      // 手机号表单校验
      const checkMobileRes = checkMobileFormat(this);
      if (!checkMobileRes) return;
      try {
        this.vertifySendStatus = 0;
        const authKey = await this.getPhoneVerifyCode({ account: this.registerForm.mobile });
        this.registerForm.authKey = authKey;
        this.handleVertifyTimeChange();
      } catch (error) {
        this.vertifySendStatus = 1;
        this.errorMsg = '验证码发送失败，请重试';
        console.error(error);
      }
    },

    // 验证码倒计时
    handleVertifyTimeChange() {
      this.timer = setInterval(() => {
        this.vertifyCodeTime -= 1;
        if (this.vertifyCodeTime <= 0) {
          this.vertifySendStatus = 1;
          this.vertifyCodeTime = 60;
          this.sendBtnText = '重新发送';
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    // 手机验证码校验
    async handleCheckPhoneVerifyCode(authCode) {
      try {
        const authKey = this.registerForm.authKey || localStorage.getItem('PHONE_AK');
        const checkRes = await this.checkPhoneVerifyCode({ authCode, authKey, phoneNum: this.registerForm.mobile });
        if (checkRes === 'success') {
          return Promise.resolve(checkRes);
        } else {
          this.$message.error('请输入正确的验证码');
          return Promise.reject(checkRes);
        }
      } catch (error) {
        console.error(error);
      }
    },

    // 提交表单注册
    async submitForm() {
      // 表单校验
      const formatRes = checkRegisterFormFormat(this.registerForm, this);
      if (!formatRes) return;
      // 表单校验通过 => 执行手机验证码校验
      this.handleCheckPhoneVerifyCode(this.registerForm.authCode)
        .then(async () => {
          // 手机验证码校验通过 => 收集参数，发送注册请求
          const {
            city,
            companyName,
            contactAddress,
            district,
            mobile,
            name,
            password,
            primaryIndustry,
            province,
            qqNumber,
            scale,
            secondaryIndustry,
            username,
          } = this.registerForm;
          const params = {
            city,
            companyName,
            contactAddress,
            district,
            mobile,
            name,
            password,
            primaryIndustry,
            province,
            qqNumber,
            scale,
            secondaryIndustry,
            username,
          };
          try {
            await this.submitUserRegister(params);
            // 删除注册流程中缓存的验证信息数据
            this.removeAuthKey();
            this.$message({
              message: '注册成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.$router.replace({
                  path: '/login',
                });
              },
            });
          } catch (error) {
            console.error(error);
          }
        })
        .catch(err => {
          // 手机验证码校验失败
          console.error(err);
        });
    },

    // 删除缓存的验证信息数据
    removeAuthKey() {
      try {
        localStorage.removeItem('PHONE_AK');
        localStorage.removeItem('EMAIL_AK');
      } catch (error) {
        console.error(error);
      }
    },

    // 初始化获取数据
    async getInitData() {
      await Promise.race([this.getIndustryOptions(), this.getAddressOptions()]);
      this.registerForm.username = this.$route.query.emailAccount;
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 90vh;
  display: flex;
  flex-direction: column;
  padding: 5vh;
}
.name {
  font-size: 22px;
  color: #333;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
}
.content {
  display: flex;
  width: 800px;
  margin: auto;
}
.left {
  // background: rgba(221, 223, 227, 1);
  box-shadow: 0px 3px 6px rgba(67, 89, 183, 0.16);
  opacity: 1;
  border-radius: 8px 0px 0px 8px;
}
.right {
  width: 50%;
  min-height: 400px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(67, 89, 183, 0.2);
  opacity: 1;
  border-radius: 0px 8px 8px 0px;
  .name {
    font-size: 22px;
    color: #333;
    padding: 18px 0;
    text-align: center;
    margin-bottom: 0;
  }
  .error {
    color: #ff5f5f;
    font-size: 14px;
    min-height: 24px;
    padding: 0 30px;
  }
  .industry {
    display: flex;
    justify-content: space-between;
    .el-select {
      width: 170px;
    }
  }
  .address {
    .el-select {
      width: 106px;
    }
  }
  .scale {
    width: 360px;
  }
  .form {
    max-width: 360px;
    margin: auto;
    .el-form-item {
      text-align: left;
      margin-bottom: 12px !important;
    }
  }
  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }
  .contacts {
    /deep/.el-form-item__content {
      font-size: 14px;
      color: #333;
      line-height: 0;
      padding: 15px 0 6px 0;
    }
  }
  .other {
    /deep/.el-form-item__content {
      font-size: 14px;
      color: #333;
      line-height: 0;
      padding: 15px 0 31px 0;
    }
  }
  .login-btn {
    width: 360px;
    font-size: 14px;
    font-family: Helvetica Neue;
    font-weight: 400;
  }
  /deep/.el-input-group__append {
    width: 95px;
    background: #4359b7;
    color: #fff;
    text-align: center;
    cursor: pointer;
  }
}
</style>
